<template>
    <!-- Página -->
    <div
        v-if="layout === 'page'"
        class="container-fluid text-left page-card weflix-admin-editCupon"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <template v-if="!hideHeading">
            <h1 class="card-title mb-2">Editar Cupom</h1>
            <p class="card-subtitle mb-4 mb-md-0">Edite as informações do cupom</p>
            <hr class="page-card__divider mb-md-6" />
        </template>

        <div class="row" v-if="hasReady">
            <div class="col-12 col-md-6 m-0 mb-3">
                <div>
                    <label class="labeld"
                        >Código do cupom<v-tooltip
                            text="Campo obrigatório"
                            location="top"
                        >
                            <template v-slot:activator="{ props }">
                                <fa
                                    v-bind="props"
                                    icon="fa-solid fa-circle-exclamation"
                                ></fa>
                            </template> </v-tooltip
                    ></label>
                </div>
                <div class="form-input">
                    <input
                        type="text"
                        required
                        class="inputd mb-1"
                        v-model="code"
                        placeholder="Off10"
                    />
                    <small>Nome comercial de sua coleção, uso externo.</small>
                </div>
            </div>

            <div class="col-12 col-md-6 m-0 mb-3">
                <div>
                    <label class="labeld"
                        >Desconto do cupom %<v-tooltip
                            text="Campo obrigatório"
                            location="top"
                        >
                            <template v-slot:activator="{ props }">
                                <fa
                                    v-bind="props"
                                    icon="fa-solid fa-circle-exclamation"
                                ></fa>
                            </template> </v-tooltip
                    ></label>
                </div>
                <div class="form-input">
                    <input
                        type="text"
                        required
                        class="inputd mb-1"
                        v-model="discount"
                        placeholder="10"
                    />
                    <small>Nome comercial de sua coleção, uso externo.</small>
                </div>
            </div>

            <div class="col-12 col-md-6 m-0 mb-3">
                <div>
                    <label class="labeld" :for="idPrefix + '-status'"
                        >Status<v-tooltip text="Campo obrigatório" location="top">
                            <template v-slot:activator="{ props }">
                                <fa
                                    v-bind="props"
                                    icon="fa-solid fa-circle-exclamation"
                                ></fa>
                            </template> </v-tooltip
                    ></label>
                </div>
                <div class="form-input web-mobile-form">
                    <CustomToggle
                        class="mb-1"
                        :id="idPrefix + '-status'"
                        v-model="status"
                    />
                    <small>Ative para permitir que o cupom seja utilizado.</small>
                </div>
            </div>

            <div class="col-12 col-md-6 m-0 mb-3">
                <div>
                    <label class="labeld"
                        >Data de Expiração<v-tooltip
                            text="Campo obrigatório"
                            location="top"
                        >
                            <template v-slot:activator="{ props }">
                                <fa
                                    v-bind="props"
                                    icon="fa-solid fa-circle-exclamation"
                                ></fa>
                            </template> </v-tooltip
                    ></label>
                </div>
                <div class="form-input">
                    <input
                        type="date"
                        required
                        class="inputd mb-1"
                        v-model="expired"
                    />
                </div>
            </div>
            <hr class="page-card__divider" />
        </div>

        <div
            class="d-flex align-items-center justify-content-center justify-content-md-end ga-3 mt-5 mt-md-7"
        >
            <v-btn
                variant="outlined"
                color="primary"
                :size="$vuetify.display.xs ? 'default' : 'large'"
                :disabled="!hasReady || saving"
                @click="onCancel"
            >
                Voltar
            </v-btn>
            <v-btn
                variant="flat"
                color="primary"
                :size="$vuetify.display.xs ? 'default' : 'large'"
                :loading="saving"
                :disabled="!hasReady || saving"
                @click="submitEdit"
                >Salvar</v-btn
            >
        </div>
        <Loader :hasReady="hasReady" />
    </div>

    <!-- Modal -->
    <div v-else class="edit-cupon-form edit-cupon-form--modal text-left">
        <Loader :hasReady="hasReady" />
        <div v-if="hasReady" class="d-flex flex-column flex-grow-1">
            <div class="row">
                <div class="col-12 col-md-6 m-0 mb-3">
                    <div>
                        <label class="labeld"
                            >Código do cupom<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div class="form-input">
                        <input
                            type="text"
                            required
                            class="inputd mb-1"
                            v-model="code"
                            placeholder="Off10"
                        />
                        <small>Nome comercial de sua coleção, uso externo.</small>
                    </div>
                </div>

                <div class="col-12 col-md-6 m-0 mb-3">
                    <div>
                        <label class="labeld"
                            >Desconto do cupom %<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div class="form-input">
                        <input
                            type="text"
                            required
                            class="inputd mb-1"
                            v-model="discount"
                            placeholder="10"
                        />
                        <small>Nome comercial de sua coleção, uso externo.</small>
                    </div>
                </div>

                <div class="col-12 col-md-6 m-0 mb-3">
                    <div>
                        <label class="labeld" :for="idPrefix + '-status'"
                            >Status<v-tooltip text="Campo obrigatório" location="top">
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div class="form-input web-mobile-form">
                        <CustomToggle
                            class="mb-1"
                            :id="idPrefix + '-status'"
                            v-model="status"
                        />
                        <small>Ative para permitir que o cupom seja utilizado.</small>
                    </div>
                </div>

                <div class="col-12 col-md-6 m-0 mb-3">
                    <div>
                        <label class="labeld"
                            >Data de Expiração<v-tooltip
                                text="Campo obrigatório"
                                location="top"
                            >
                                <template v-slot:activator="{ props }">
                                    <fa
                                        v-bind="props"
                                        icon="fa-solid fa-circle-exclamation"
                                    ></fa>
                                </template> </v-tooltip
                        ></label>
                    </div>
                    <div class="form-input">
                        <input
                            type="date"
                            required
                            class="inputd mb-1"
                            v-model="expired"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="hasReady"
            class="d-flex align-items-center justify-content-center justify-content-md-end ga-3 mt-5 mt-md-7"
        >
            <v-btn
                variant="outlined"
                color="primary"
                :size="$vuetify.display.xs ? 'default' : 'large'"
                :disabled="saving"
                @click="onCancel"
            >
                Voltar
            </v-btn>
            <v-btn
                variant="flat"
                color="primary"
                :size="$vuetify.display.xs ? 'default' : 'large'"
                :loading="saving"
                :disabled="saving"
                @click="submitEdit"
                >Salvar</v-btn
            >
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import { toast } from 'vue3-toastify';
    import Cupom from '@/utils/Weflix/cupom';
    import Loader from '@/components/Weflix/Loader';
    import CustomToggle from '@/components/Form/CustomToggle.vue';

    export default {
        name: 'EditCuponForm',
        components: {
            Loader,
            CustomToggle,
        },
        emits: ['success', 'cancel', 'saving-change'],
        props: {
            cupomId: {
                type: String,
                default: '',
            },
            layout: {
                type: String,
                default: 'page',
                validator: (v) => ['page', 'modal'].includes(v),
            },
            hideHeading: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                code: '',
                discount: '',
                expired: '',
                status: false,
                selectedPlan: '',
                hasReady: false,
                saving: false,
            };
        },
        computed: {
            ...mapState(['token']),
            idPrefix() {
                return this.layout === 'modal'
                    ? 'modal-edit-cupon'
                    : 'page-edit-cupon';
            },
        },
        watch: {
            cupomId: {
                immediate: true,
                handler(id) {
                    if (id) this.loadCupom();
                },
            },
            saving(val) {
                this.$emit('saving-change', val);
            },
        },
        methods: {
            formatDateToISO(date) {
                const d = new Date(date);
                return d.toISOString();
            },
            formatDate(isoDate) {
                const date = new Date(isoDate);
                const year = date.getUTCFullYear();
                const month = String(date.getUTCMonth() + 1).padStart(2, '0');
                const day = String(date.getUTCDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            },
            async loadCupom() {
                if (!this.cupomId) return;
                this.hasReady = false;
                try {
                    const response = await Cupom.getCupomById(
                        this.token,
                        this.cupomId
                    );
                    this.code = response.code;
                    this.discount = response.discount;
                    this.expired = this.formatDate(response.expired);
                    this.status = response.status == 1;
                    this.hasReady = true;
                } catch (error) {
                    console.error(error);
                    this.notify('Erro ao carregar o cupom.', 'error');
                    this.hasReady = true;
                }
            },
            onCancel() {
                this.$emit('cancel');
            },
            async submitEdit() {
                if (!this.cupomId) return;
                const payload = {
                    title: this.code,
                    code: this.code,
                    defaul: 0,
                    status: this.status ? 1 : 0,
                    expired: this.formatDateToISO(this.expired),
                    discount: this.discount,
                    planId: this.selectedPlan,
                };
                this.saving = true;
                try {
                    await Cupom.editCupom(this.token, this.cupomId, payload);
                    this.notify('Cupom editado com sucesso!', 'success');
                    this.$emit('success');
                } catch (error) {
                    this.notify('Erro ao editar cupom!', 'error');
                    console.error(error);
                } finally {
                    this.saving = false;
                }
            },
            notify(message, type = 'info') {
                toast(message, {
                    autoClose: 3000,
                    position: 'top-right',
                    theme: 'light',
                    limit: 1,
                    type: type,
                    dangerouslyHTMLString: true,
                });
            },
        },
    };
</script>

<style scoped>
    @import '@/Views/Weflix/Adm/global.css';

    .contetContainerNewPlan {
        display: flex;
        flex-wrap: wrap;
    }

    .edit-cupon-form--modal {
        min-height: 120px;
        position: relative;
    }

    @media (max-width: 600px) {
        .weflix-admin-editCupon h3 {
            font-size: 20px;
            margin-bottom: 5px;
        }

        .weflix-admin-editCupon small {
            font-size: 12px;
            color: #666;
        }

        .weflix-admin-editCupon .contetContainerNewPlan {
            padding: 0px 10px;
        }
    }
</style>
